<template>
  <v-dialog persistent :value="true">
    <v-sheet width="100%">
      <v-btn
        fab
        fixed
        right
        icon
        top
        x-large
        color="primary"
        @click="closeModal"
      >
        <v-icon> far fa-window-close</v-icon>
      </v-btn>
      <v-row v-if="images.length === 0">
        <!-- <a :href="getFile(pdf)" :download="pdf" style="width: 100%;"> -->
        <v-img :src="renderImage(image)" eager />
        <!-- </a> -->
      </v-row>
      <v-row v-for="image in images" v-else :key="image">
        <v-img :src="renderImage(image)" eager />
      </v-row>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  name: "ImagePopup",
  props: {
    images: {
      type: Array,
      default: () => []
    },
    image: {
      type: String
    },
    closeModal: {
      type: Function
    },
    pdf: {
      type: String
    }
  },
  created() {},
  methods: {
    renderImage(imageName) {
      return require(`../../public/static/slides/${imageName}`);
    }
  }
};
</script>

<style scoped>
.v-btn--fixed.v-btn--right {
  right: 50px !important;
}
.v-btn--fixed.v-btn--top {
  top: 75px !important;
}
@media only screen and (min-width: 350px) and (max-width: 1023px) {
  .v-btn--fixed.v-btn--right {
    right: 10% !important;
  }
  .v-btn--fixed.v-btn--top {
    top: 10% !important;
  }
}
</style>

<style>
.v-btn--fab.v-btn--fixed,
.v-btn--fab.v-btn--absolute {
  z-index: 205 !important;
}
</style>
